
import { formatDateToDDMMYYYY, formatDateToYYYYMMDD } from "../../utils/dateUtils";
import React, { useState, useEffect } from 'react';
import axios from '../../config/axiosConfig';
import { MdArrowBack } from 'react-icons/md';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// Components defined outside to prevent re-mounting on every render
const InputField = ({ label, name, type = "text", required = false, placeholder = "", value, onChange }) => (
    <div>
        <label className="block text-sm font-medium text-gray-700">
            {label} {required && <span className="text-red-500">*</span>}
        </label>
        <input 
            type={type} 
            name={name} 
            required={required} 
            value={value}
            onChange={onChange} 
            placeholder={placeholder}
            className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 border p-2" 
        />
    </div>
);

const SelectField = ({ label, name, options, required = false, value, onChange }) => (
    <div>
        <label className="block text-sm font-medium text-gray-700">
            {label} {required && <span className="text-red-500">*</span>}
        </label>
        <select 
            name={name} 
            required={required} 
            value={value}
            onChange={onChange} 
            className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 border p-2"
        >
            <option value="">Select {label}</option>
            {options.map(opt => <option key={opt} value={opt}>{opt}</option>)}
        </select>
    </div>
);

const AddMember = ({ onBack, onMemberAdded }) => {
    const [formData, setFormData] = useState({
        member_name: '',
        member_id: '',
        member_code: '',
        member_type: 'MEMBER', // MEMBER or LEADER
        member_type_choice: 'Journalist', // Journalist, Reporter...
        member_status: 'ACTIVE',
        
        leadership_place: '',
        leadership_designation: '',
        leadership_wing: '',
        
        registered_on: '',
        valid_till: '',
        last_renewed_on: '',
        renewal: 'Not Renewed',
        member_age: '',
        last_renewed_on: '',
        renewal: 'Not Renewed',
        member_age: '',
        membership_age: '',

        // Payment Details
        membership_amount: '',
        membership_payment_date: '',
        leadership_amount: '',
        leadership_payment_date: '',
        
        mobile: '',
        whatsapp_no: '',
        email: '',
        member_address: '',
        
        referrer: null,
        referrer_name: '',
        referrer_mobile_number: '',
        
        state: '',
        district: '',
        city: '',
        sub_district: '',
        zone: '',
        areaname: '',
        taluk: '',
        village: '',
        ward: '',
        
        gender: '',
        date_of_birth: '',
        religion: '',
        
        voter_id: '',
        aadhar_number: '',
        police_station: '',
        pin_code: '',
        occupation: '',
        business_designation: '',
        remarks: '',
        is_association_ambassador: false,
        slug: ''
    });
    // Dynamic Renewals List: [{ amount: '', payment_date: '' }]
    const [renewals, setRenewals] = useState([]); 
    const [picture, setPicture] = useState(null);
    const [loading, setLoading] = useState(false);

    // Referral Autocomplete State
    const [allMembers, setAllMembers] = useState([]);
    const [referralSuggestions, setReferralSuggestions] = useState([]);
    const [showSuggestions, setShowSuggestions] = useState(false);

    // Fetch all members for referral search once on load
    useEffect(() => {
        const fetchAllMembers = async () => {
            try {
                const response = await axios.get('nai-members/members/');
                setAllMembers(response.data);
            } catch (error) {
                console.error("Error fetching all members for referral:", error);
            }
        };
        fetchAllMembers();
    }, []);

    const handleReferralSearch = (query) => {
        setFormData({ ...formData, referrer_name: query });
        if (!query.trim()) {
            setReferralSuggestions([]);
            setShowSuggestions(false);
            return;
        }

        const lowerQuery = query.toLowerCase();
        const matches = allMembers.filter(member => 
            (member.member_name && member.member_name.toLowerCase().includes(lowerQuery)) ||
            (member.member_id && String(member.member_id).padStart(4, '0').includes(lowerQuery)) ||
            (member.mobile && String(member.mobile).includes(lowerQuery))
        );
        
        setReferralSuggestions(matches);
        setShowSuggestions(true);
    };

    const selectReferrer = (member) => {
        setFormData({
            ...formData,
            referrer: member.id,
            referrer_name: member.member_name,
            referrer_mobile_number: member.mobile
        });
        setShowSuggestions(false);
    };

    const indianStates = [
        "Andhra Pradesh", "Arunachal Pradesh", "Assam", "Bihar", "Chhattisgarh", "Goa", "Gujarat", 
        "Haryana", "Himachal Pradesh", "Jharkhand", "Karnataka", "Kerala", "Madhya Pradesh", 
        "Maharashtra", "Manipur", "Meghalaya", "Mizoram", "Nagaland", "Odisha", "Punjab", 
        "Rajasthan", "Sikkim", "Tamil Nadu", "Telangana", "Tripura", "Uttar Pradesh", 
        "Uttarakhand", "West Bengal", "Andaman and Nicobar Islands", "Chandigarh", 
        "Dadra and Nagar Haveli and Daman and Diu", "Delhi", "Jammu and Kashmir", "Ladakh", 
        "Lakshadweep", "Puducherry"
    ];

    const memberTypeChoices = ["MEMBER", "LEADER"];

    
    const placeChoices = [
        "National", 
        "National Regional - Northern", "National Regional - Southern", 
        "National Regional - North Western", "National Regional - North Eastern", 
        "National Regional - Eastern", "National Regional - Central", 
        "National Regional - Western",
        "State", 
        "State Regional - North", "State Regional - South", "State Regional - West", "State Regional - East",
        "District", "Sub - District", "Constituency", "Zone", "Taluk", "Ward"
    ];

    const [designationChoices, setDesignationChoices] = useState([
        "Patron", "Vice Patron", "Honorary President", "President", "Vice President",
        "General Secretary", "Joint Gen. Secretary", "Treasurer", "Ambassador",
        "Organizing Secretary", "Media Secretary", "Political Secretary",
        "Propaganda Secretary", "Legal Secretary",
        "Action Committee Member - 1", "Action Committee Member - 2",
        "Action Committee Member - 3", "Action Committee Member - 4",
        "Action Committee Member - 5", "Action Committee Member - 6",
        "Action Committee Member - 7"
    ]);

    const [memberRoleChoices, setMemberRoleChoices] = useState([
        "Citizen Reporter & Leader", 
        "Journalist & Leader",
        "Journalist", "District Reporter", "State Reporter", "Chief Reporter", 
        "Citizen Reporter", "Digital Reporter", "Mobile Reporter", "News Informer", "Volunteers"
    ]);

    const [wingChoices, setWingChoices] = useState([]);

    useEffect(() => {
        const fetchWingsAndDesignations = async () => {
            try {
                const response = await axios.get('nai-members/wings/');
                setWingChoices(response.data.map(w => w.name.toUpperCase()));
            } catch (error) {
                console.error("Error fetching wings:", error);
            }

            try {
                const desgsRes = await axios.get('nai-members/designations/');
                if (desgsRes.data && desgsRes.data.length > 0) {
                    const desgs = desgsRes.data.filter(d => d.category === 'designation').map(d => d.name);
                    const rls = desgsRes.data.filter(d => d.category === 'role').map(d => d.name);
                    if (desgs.length > 0) setDesignationChoices(desgs);
                    if (rls.length > 0) setMemberRoleChoices(rls);
                }
            } catch (error) {
                console.error("Error fetching designations:", error);
            }
        };
        fetchWingsAndDesignations();
    }, []);

    const memberStatusChoices = ["ACTIVE", "EXPIRED", "DIED", "DISMISSED", "SUSPENDED", "UNUSED"];
    const genderChoices = ["Male", "Female", "Other"];
    const renewalChoices = ["Renewed", "Not Renewed"];
    const knowUsFromChoices = ["Online", "Face Book", "Whatsapp", "Instagram"];

    const feeCategoryOptions = [
        { label: 'Membership', value: 'registration' },
        { label: 'Leadership', value: 'leadership' },
        { label: 'Renewal', value: 'renewal' },
        { label: 'Donation', value: 'donation' }
    ];

    const paymentStatusTypeOptions = [
        { label: 'Full Payment', value: 'full' },
        { label: 'Part Payment', value: 'part' }
    ];

    const paymentModeOptions = [
        'Cash',
        'UPI',
        'Bank Transfer',
        'Credit/Debit Card',
        'Cheque',
        'Other'
    ];

    const [newPayments, setNewPayments] = useState([
        {
            payment_type: 'registration',
            payment_status_type: 'full',
            amount: '',
            total_amount: '',
            balance_amount: '',
            payment_date: new Date().toISOString().split('T')[0],
            payment_mode: 'UPI',
            notes: ''
        }
    ]);

    const addNewPayment = () => {
        const todayStr = new Date().toISOString().split('T')[0];
        setNewPayments([
            ...newPayments,
            {
                payment_type: 'registration',
                payment_status_type: 'full',
                amount: '',
                total_amount: '',
                balance_amount: '',
                payment_date: todayStr,
                payment_mode: 'UPI',
                notes: ''
            }
        ]);
    };

    const removeNewPayment = (index) => {
        const updated = [...newPayments];
        updated.splice(index, 1);
        setNewPayments(updated);
    };

    const handleNewPaymentChange = (index, field, value) => {
        const updated = [...newPayments];
        const item = { ...updated[index], [field]: value };

        if (field === 'payment_status_type') {
            if (value === 'full') {
                item.total_amount = '';
                item.balance_amount = '';
            } else {
                const tot = parseFloat(item.total_amount) || 0;
                const amt = parseFloat(item.amount) || 0;
                item.balance_amount = item.total_amount ? Math.max(0, tot - amt).toFixed(2) : '';
            }
        } else if (field === 'total_amount' || field === 'amount') {
            if (item.payment_status_type === 'part') {
                const tot = field === 'total_amount' ? (parseFloat(value) || 0) : (parseFloat(item.total_amount) || 0);
                const amt = field === 'amount' ? (parseFloat(value) || 0) : (parseFloat(item.amount) || 0);
                const hasTotal = field === 'total_amount' ? !!value : !!item.total_amount;
                item.balance_amount = hasTotal ? Math.max(0, tot - amt).toFixed(2) : '';
            }
        }

        updated[index] = item;
        setNewPayments(updated);
    };

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleFileChange = (e) => {
        setPicture(e.target.files[0]);
    };

    // Renewal Handlers (for backward compatibility)
    const addRenewal = () => {
        setRenewals([...renewals, { amount: '', payment_date: '' }]);
    };

    const removeRenewal = (index) => {
        const newRenewals = [...renewals];
        newRenewals.splice(index, 1);
        setRenewals(newRenewals);
    };

    const handleRenewalChange = (index, field, value) => {
        const newRenewals = [...renewals];
        newRenewals[index][field] = value;
        setRenewals(newRenewals);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        // Validation Rules
        const validateForm = () => {
            if (!formData.member_name.trim()) return "Member Name is required.";
            if (!formData.member_id) return "NAI Member ID is required.";
            if (!formData.mobile) return "Mobile Number is required.";
            if (formData.mobile.toString().length !== 10) return "Mobile Number must be 10 digits.";
            
            if (formData.whatsapp_no && formData.whatsapp_no.toString().length !== 10) return "WhatsApp Number must be 10 digits.";
            if (formData.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) return "Invalid Email Address.";
            if (!formData.member_address.trim()) return "Address is required.";
            if (!formData.state) return "State is required.";
            if (!formData.district.trim()) return "District is required.";
            if (!formData.city.trim()) return "City is required.";
            if (!formData.pin_code) return "Pin Code is required.";
            if (formData.pin_code.toString().length !== 6) return "Pin Code must be 6 digits.";
            if (!formData.gender) return "Gender is required.";

            if (formData.member_type.toUpperCase() === "LEADER") {
                if (!formData.leadership_place) return "Leadership Place is required.";
                if (!formData.leadership_designation) return "Leadership Designation is required.";
                if (!formData.leadership_wing) return "Leadership Wing is required.";
            }

            return null; // Return null if there are no errors
        };

        const errorMsg = validateForm();
        if (errorMsg) {
            toast.error(errorMsg);
            return;
        }

        setLoading(true);

        const data = new FormData();
        
        const formatDateForBackend = (dateStr) => {
            if (!dateStr) return '';
            if (dateStr.includes('-') && dateStr.split('-')[0].length === 4) return dateStr; // Already YYYY-MM-DD
            const parts = dateStr.split('/');
            if (parts.length === 3) {
                if (parts[0].length === 4) {
                    return `${parts[0]}-${parts[1]}-${parts[2]}`;
                }
                return `${parts[2]}-${parts[1]}-${parts[0]}`;
            }
            return dateStr; // Fallback
        };

        const dateFields = ['registered_on', 'valid_till', 'last_renewed_on', 'date_of_birth', 'membership_payment_date', 'leadership_payment_date'];

        Object.keys(formData).forEach(key => {
            if (formData[key] !== '' && formData[key] !== null) {
                if (dateFields.includes(key)) {
                    data.append(key, formatDateForBackend(formData[key]));
                } else if (key === 'slug' && typeof formData[key] === 'string') {
                    // Sanitize slug by removing leading/trailing slashes
                    data.append(key, formData[key].replace(/^\/|\/$/g, ''));
                } else {
                    data.append(key, formData[key]);
                }
            }
        });
        if (picture) {
            data.append('picture', picture);
        }

        // Append Renewals (backward compatibility)
        const validRenewals = renewals
            .filter(r => r.amount && String(r.amount).trim() !== '')
            .map(r => ({
                amount: r.amount,
                payment_date: formatDateForBackend(r.payment_date) || null
            }));

        if (validRenewals.length > 0) {
            data.append('renewals', JSON.stringify(validRenewals));
        }

        // Append New Payments
        const validNewPayments = newPayments
            .filter(p => p.amount && String(p.amount).trim() !== '')
            .map(p => ({
                payment_type: p.payment_type || 'registration',
                payment_status_type: p.payment_status_type || 'full',
                amount: p.amount,
                total_amount: p.payment_status_type === 'part' && p.total_amount ? p.total_amount : null,
                balance_amount: p.payment_status_type === 'part' && p.balance_amount ? p.balance_amount : null,
                payment_date: formatDateForBackend(p.payment_date) || null,
                payment_mode: p.payment_mode || 'Cash',
                notes: p.notes || ''
            }));

        if (validNewPayments.length > 0) {
            data.append('new_payments', JSON.stringify(validNewPayments));
        }

        try {
            await axios.post('nai-members/members/', data, {
                headers: { 'Content-Type': 'multipart/form-data' }
            });
            toast.success('Member added successfully!');
            setTimeout(onMemberAdded, 1500);
        } catch (error) {
            console.error(error);
            const errorMsg = error.response?.data ? JSON.stringify(error.response.data) : 'Failed to add member.';
            toast.error(errorMsg);
        } finally {
            setLoading(false);
        }
    };
    // Calculate Member Age and Membership Age
    React.useEffect(() => {
        const calculateAges = () => {
            const { registered_on, valid_till } = formData;
            if (!registered_on) return;

            const regParts = registered_on.split('/');
            if (regParts.length !== 3) return;
            const regYear = parseInt(regParts[2]);

            // Membership Age: Current Year - Registration Year
            const currentYear = new Date().getFullYear();
            const memAge = currentYear - regYear;
            
            // Member Age: Valid Till Year - Registration Year
            let mAge = '';
            if (valid_till) {
                const validParts = valid_till.split('/');
                if (validParts.length === 3) {
                    const validYear = parseInt(validParts[2]);
                    mAge = validYear - regYear;
                }
            }

            setFormData(prev => ({
                ...prev,
                membership_age: memAge >= 0 ? `${memAge} Years` : '',
                member_age: mAge !== '' && mAge >= 0 ? `${mAge} Years` : ''
            }));
        };
        
        // Debounce slightly to avoid rapid updates while typing
        const timer = setTimeout(calculateAges, 500);
        return () => clearTimeout(timer);
    }, [formData.registered_on, formData.valid_till]);
    
    // ...

    return (
        <div className="bg-white rounded-lg shadow p-6">
            <button onClick={onBack} className="flex items-center text-gray-600 hover:text-gray-900 mb-6">
                <MdArrowBack className="mr-2" /> Back to Members
            </button>
            
            <h2 className="text-xl font-bold text-gray-800 mb-6">Add New Member</h2>

            <ToastContainer position="bottom-center" theme="dark" />
            
            <form onSubmit={handleSubmit} className="space-y-8 max-w-6xl">
                
                {/* 1. Basic Information */}
                <section>
                    <h3 className="text-lg font-medium text-gray-900 mb-4 border-b pb-2">Basic Information</h3>
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                        <InputField label="Member Name" name="member_name" required={true} value={formData.member_name} onChange={handleChange} />
                        <InputField label="NAI Member ID (Unique)" name="member_id" type="number" required={true} value={formData.member_id} onChange={handleChange} />
                        <InputField label="DMCR Member Code" name="member_code" value={formData.member_code} onChange={handleChange} />
                        
                        <div className="flex items-center space-x-2 mt-6">
                            <input 
                                type="checkbox" 
                                id="is_association_ambassador" 
                                name="is_association_ambassador"
                                checked={formData.is_association_ambassador}
                                onChange={(e) => setFormData({ ...formData, is_association_ambassador: e.target.checked })}
                                className="h-5 w-5 text-blue-600 focus:ring-blue-500 border-gray-300 rounded cursor-pointer"
                            />
                            <label htmlFor="is_association_ambassador" className="text-sm font-bold text-blue-700 cursor-pointer uppercase">
                                Association Ambassador
                            </label>
                        </div>
                        
                        <SelectField label="Member Type" name="member_type" options={memberTypeChoices} required={true} value={formData.member_type} onChange={handleChange} />
                        <SelectField label="Designation / Role" name="member_type_choice" options={memberRoleChoices} required={true} value={formData.member_type_choice} onChange={handleChange} />
                        <SelectField label="Status" name="member_status" options={memberStatusChoices} required={true} value={formData.member_status} onChange={handleChange} />
                        <InputField label="Profile URL Slug (Optional)" name="slug" value={formData.slug} onChange={handleChange} placeholder="member/a-dilli-babu" />
                    </div>
                    
                    {(formData.member_type.toUpperCase() === "LEADER") && (
                        <div className="mt-6 p-4 bg-blue-50 rounded-md border border-blue-100">
                            <h4 className="text-md font-medium text-blue-900 mb-4">Leadership Details</h4>
                            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                                <SelectField 
                                    label="Place" 
                                    name="leadership_place" 
                                    options={placeChoices} 
                                    required={true} 
                                    value={formData.leadership_place} 
                                    onChange={handleChange} 
                                />
                                <SelectField 
                                    label="Designation" 
                                    name="leadership_designation" 
                                    options={designationChoices} 
                                    required={true} 
                                    value={formData.leadership_designation} 
                                    onChange={handleChange} 
                                />
                                <div>
                                    <label className="block text-sm font-medium text-gray-700">
                                        Wings <span className="text-red-500">*</span>
                                    </label>
                                    <input 
                                        list="wings-options" 
                                        name="leadership_wing" 
                                        required 
                                        value={formData.leadership_wing}
                                        onChange={handleChange} 
                                        className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 border p-2"
                                        placeholder="Search Wings..."
                                    />
                                    <datalist id="wings-options">
                                        {wingChoices.map(wing => (
                                            <option key={wing} value={wing} />
                                        ))}
                                    </datalist>
                                </div>
                            </div>
                        </div>
                    )}
                </section>

                {/* 2. Registration & Dates */}
                <section>
                    <h3 className="text-lg font-medium text-gray-900 mb-4 border-b pb-2">Registration Details</h3>
                    <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
                         <InputField label="Registered On" name="registered_on" type="date" required={true} value={formatDateToYYYYMMDD(formData.registered_on)} onChange={handleChange} />
                         <InputField label="Valid Till" name="valid_till" type="date" required={true} value={formatDateToYYYYMMDD(formData.valid_till)} onChange={handleChange} />
                         <InputField label="Last Renewed On" name="last_renewed_on" type="date" value={formatDateToYYYYMMDD(formData.last_renewed_on)} onChange={handleChange} />
                         <SelectField label="Renewal Status" name="renewal" options={renewalChoices} value={formData.renewal} onChange={handleChange} />
                    </div>
                    <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mt-4">
                         <InputField label="Member Age (Duration)" name="member_age" value={formData.member_age} onChange={handleChange} placeholder="Auto-calculated" />
                         <InputField label="Membership Age (Tenure)" name="membership_age" value={formData.membership_age} onChange={handleChange} placeholder="Auto-calculated" />
                    </div>
                </section>

                {/* 3. Contact Details */}
                <section>
                    <h3 className="text-lg font-medium text-gray-900 mb-4 border-b pb-2">Contact Details</h3>
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                        <InputField label="Mobile Number" name="mobile" type="number" required={true} value={formData.mobile} onChange={handleChange} />
                        <InputField label="WhatsApp Number" name="whatsapp_no" type="number" value={formData.whatsapp_no} onChange={handleChange} />
                        <InputField label="Email" name="email" type="email" value={formData.email} onChange={handleChange} />
                        <div className="col-span-1 md:col-span-3">
                            <label className="block text-sm font-medium text-gray-700">
                                Address <span className="text-red-500">*</span>
                            </label>
                            <textarea name="member_address" rows={2} required value={formData.member_address} onChange={handleChange} className="mt-1 block w-full rounded-md border-gray-300 shadow-sm border p-2" />
                        </div>
                    </div>
                </section>

                {/* 4. Location Details */}
                <section>
                    <h3 className="text-lg font-medium text-gray-900 mb-4 border-b pb-2">Location Details</h3>
                    <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
                        <SelectField label="State" name="state" options={indianStates} required={true} value={formData.state} onChange={handleChange} />
                        <InputField label="District" name="district" required={true} value={formData.district} onChange={handleChange} />
                        <InputField label="City" name="city" required={true} value={formData.city} onChange={handleChange} />
                        <InputField label="Sub District" name="sub_district" value={formData.sub_district} onChange={handleChange} />
                        
                        <InputField label="Zone" name="zone" value={formData.zone} onChange={handleChange} />
                        <InputField label="Area Name" name="areaname" value={formData.areaname} onChange={handleChange} />
                        <InputField label="Taluk" name="taluk" value={formData.taluk} onChange={handleChange} />
                        <InputField label="Village" name="village" value={formData.village} onChange={handleChange} />
                        
                        <InputField label="Ward" name="ward" value={formData.ward} onChange={handleChange} />
                        <InputField label="Pin Code" name="pin_code" required={true} value={formData.pin_code} onChange={handleChange} />
                        <InputField label="Police Station" name="police_station" value={formData.police_station} onChange={handleChange} />
                    </div>
                </section>

                {/* 5. Personal Details */}
                <section>
                    <h3 className="text-lg font-medium text-gray-900 mb-4 border-b pb-2">Personal & Identity Details</h3>
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                        <SelectField label="Gender" name="gender" options={genderChoices} required={true} value={formData.gender} onChange={handleChange} />
                        <InputField label="Date of Birth" name="date_of_birth" type="date" value={formatDateToYYYYMMDD(formData.date_of_birth)} onChange={handleChange} />
                        <InputField label="Religion" name="religion" value={formData.religion} onChange={handleChange} />
                        
                        <InputField label="Voter ID" name="voter_id" value={formData.voter_id} onChange={handleChange} />
                        <InputField label="Aadhar Number" name="aadhar_number" value={formData.aadhar_number} onChange={handleChange} />
                        <InputField label="Occupation" name="occupation" value={formData.occupation} onChange={handleChange} />
                        
                        <InputField label="Business" name="business" value={formData.business} onChange={handleChange} />
                        <InputField label="Business Designation" name="business_designation" value={formData.business_designation} onChange={handleChange} />
                    </div>
                </section>

                {/* Unified Section: Payment Details */}
                <section>
                    <h3 className="text-lg font-medium text-gray-900 mb-4 border-b pb-2">Payment Details</h3>

                    <div className="p-5 bg-gray-50 rounded-lg border border-gray-200">
                        <div className="flex flex-col sm:flex-row justify-between sm:items-center mb-4 gap-2">
                            <div>
                                <h4 className="text-md font-bold text-gray-800">Add New Payments</h4>
                                <p className="text-sm text-gray-500">Record initial fees, leadership fees, renewals, or donations (Full or Part Payment).</p>
                            </div>
                            <button 
                                type="button" 
                                onClick={addNewPayment} 
                                className="inline-flex items-center text-sm bg-blue-600 hover:bg-blue-700 text-white font-medium px-4 py-2 rounded-md shadow-sm transition"
                            >
                                + Add Payment
                            </button>
                        </div>

                        {newPayments.length === 0 ? (
                            <div className="text-center py-6 border-2 border-dashed border-gray-300 rounded-md bg-white">
                                <p className="text-sm text-gray-500 mb-2">No payments added for this new member.</p>
                                <button
                                    type="button"
                                    onClick={addNewPayment}
                                    className="text-sm text-blue-600 font-semibold hover:underline"
                                >
                                    + Click to record initial payment
                                </button>
                            </div>
                        ) : (
                            <div className="space-y-4">
                                {newPayments.map((p, index) => (
                                    <div key={index} className="p-4 bg-white rounded-lg border border-gray-200 shadow-sm space-y-4">
                                        <div className="flex justify-between items-center border-b pb-2">
                                            <span className="font-semibold text-sm text-gray-800">Payment Entry #{index + 1}</span>
                                            <button 
                                                type="button" 
                                                onClick={() => removeNewPayment(index)} 
                                                className="text-xs text-red-600 hover:text-red-800 font-semibold"
                                            >
                                                ✕ Remove
                                            </button>
                                        </div>

                                        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
                                            {/* Member Type / Fee Type */}
                                            <div>
                                                <label className="block text-sm font-medium text-gray-700">
                                                    Member Type / Fee <span className="text-red-500">*</span>
                                                </label>
                                                <select
                                                    value={p.payment_type}
                                                    onChange={(e) => handleNewPaymentChange(index, 'payment_type', e.target.value)}
                                                    className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 border p-2 text-sm bg-white"
                                                >
                                                    {feeCategoryOptions.map(opt => (
                                                        <option key={opt.value} value={opt.value}>{opt.label}</option>
                                                    ))}
                                                </select>
                                            </div>

                                            {/* Payment Type */}
                                            <div>
                                                <label className="block text-sm font-medium text-gray-700">
                                                    Payment Type <span className="text-red-500">*</span>
                                                </label>
                                                <select
                                                    value={p.payment_status_type}
                                                    onChange={(e) => handleNewPaymentChange(index, 'payment_status_type', e.target.value)}
                                                    className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 border p-2 text-sm bg-white"
                                                >
                                                    {paymentStatusTypeOptions.map(opt => (
                                                        <option key={opt.value} value={opt.value}>{opt.label}</option>
                                                    ))}
                                                </select>
                                            </div>

                                            {/* Mode of Payment */}
                                            <div>
                                                <label className="block text-sm font-medium text-gray-700">
                                                    Mode of Payment <span className="text-red-500">*</span>
                                                </label>
                                                <select
                                                    value={p.payment_mode}
                                                    onChange={(e) => handleNewPaymentChange(index, 'payment_mode', e.target.value)}
                                                    className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 border p-2 text-sm bg-white"
                                                >
                                                    {paymentModeOptions.map(mode => (
                                                        <option key={mode} value={mode}>{mode}</option>
                                                    ))}
                                                </select>
                                            </div>

                                            {/* Payment Date */}
                                            <div>
                                                <label className="block text-sm font-medium text-gray-700">
                                                    Payment Date <span className="text-red-500">*</span>
                                                </label>
                                                <input
                                                    type="date"
                                                    value={formatDateToYYYYMMDD(p.payment_date)}
                                                    onChange={(e) => handleNewPaymentChange(index, 'payment_date', e.target.value)}
                                                    className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 border p-2 text-sm bg-white"
                                                />
                                            </div>
                                        </div>

                                        {/* Amount & Balance Fields */}
                                        {p.payment_status_type === 'part' ? (
                                            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 p-3 bg-amber-50 rounded-md border border-amber-200">
                                                <div>
                                                    <label className="block text-sm font-medium text-amber-900">
                                                        Total Amount (₹) <span className="text-red-500">*</span>
                                                    </label>
                                                    <input
                                                        type="number"
                                                        step="0.01"
                                                        placeholder="e.g. 5000"
                                                        value={p.total_amount}
                                                        onChange={(e) => handleNewPaymentChange(index, 'total_amount', e.target.value)}
                                                        className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 border p-2 text-sm bg-white"
                                                    />
                                                </div>
                                                <div>
                                                    <label className="block text-sm font-medium text-amber-900">
                                                        Amount Paid (₹) <span className="text-red-500">*</span>
                                                    </label>
                                                    <input
                                                        type="number"
                                                        step="0.01"
                                                        placeholder="e.g. 2000"
                                                        value={p.amount}
                                                        onChange={(e) => handleNewPaymentChange(index, 'amount', e.target.value)}
                                                        className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 border p-2 text-sm bg-white"
                                                    />
                                                </div>
                                                <div>
                                                    <label className="block text-sm font-medium text-amber-900">
                                                        Balance Amount (₹) <span className="text-xs text-amber-700">(Auto-calculated)</span>
                                                    </label>
                                                    <input
                                                        type="text"
                                                        readOnly
                                                        value={p.balance_amount !== '' ? `₹ ${p.balance_amount}` : '-'}
                                                        className="mt-1 block w-full rounded-md border-amber-300 bg-amber-100 text-amber-900 font-bold p-2 text-sm cursor-not-allowed"
                                                    />
                                                </div>
                                            </div>
                                        ) : (
                                            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                                                <div>
                                                    <label className="block text-sm font-medium text-gray-700">
                                                        Amount Paid (₹) <span className="text-red-500">*</span>
                                                    </label>
                                                    <input
                                                        type="number"
                                                        step="0.01"
                                                        placeholder="e.g. 1000"
                                                        value={p.amount}
                                                        onChange={(e) => handleNewPaymentChange(index, 'amount', e.target.value)}
                                                        className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 border p-2 text-sm bg-white"
                                                    />
                                                </div>
                                                <div>
                                                    <label className="block text-sm font-medium text-gray-700">Notes / Remarks (Optional)</label>
                                                    <input
                                                        type="text"
                                                        placeholder="e.g. Reference / Cheque No"
                                                        value={p.notes}
                                                        onChange={(e) => handleNewPaymentChange(index, 'notes', e.target.value)}
                                                        className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 border p-2 text-sm bg-white"
                                                    />
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                </section>

                {/* 6. Referral Information */}
                <section>
                    <h3 className="text-lg font-medium text-gray-900 mb-4 border-b pb-2">Referral Information</h3>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 relative">
                        <div>
                            <label className="block text-sm font-medium text-gray-700">
                                Referrer Search (by Name, ID, or Mobile)
                            </label>
                            <input 
                                type="text"
                                name="referrer_name"
                                value={formData.referrer_name}
                                onChange={(e) => handleReferralSearch(e.target.value)}
                                onFocus={() => formData.referrer_name && handleReferralSearch(formData.referrer_name)}
                                onBlur={() => setTimeout(() => setShowSuggestions(false), 200)}
                                placeholder="Type to search members..."
                                className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 border p-2" 
                            />
                            
                            {showSuggestions && referralSuggestions.length > 0 && (
                                <ul className="absolute z-10 mt-1 w-[48%] bg-white shadow-lg max-h-60 rounded-md py-1 text-base ring-1 ring-black ring-opacity-5 overflow-auto focus:outline-none sm:text-sm">
                                    {referralSuggestions.map((member) => (
                                        <li 
                                            key={member.id}
                                            onClick={() => selectReferrer(member)}
                                            className="cursor-pointer select-none relative py-2 pl-3 pr-9 hover:bg-blue-600 hover:text-white group"
                                        >
                                            <div className="flex flex-col">
                                                <span className="font-semibold block truncate">
                                                    {member.member_name} (ID: {member.member_id ? String(member.member_id).padStart(4, '0') : ''})
                                                </span>
                                                <span className="text-gray-500 group-hover:text-blue-200 text-xs">
                                                    {member.mobile} • {member.district}
                                                </span>
                                            </div>
                                        </li>
                                    ))}
                                </ul>
                            )}
                        </div>
                        <InputField label="Referrer Mobile" name="referrer_mobile_number" type="number" required={false} value={formData.referrer_mobile_number} onChange={handleChange} />
                    </div>
                </section>

                {/* 7. Other */}
                <section>
                    <h3 className="text-lg font-medium text-gray-900 mb-4 border-b pb-2">Other Information</h3>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        <SelectField label="Know us from" name="know_us_from" options={knowUsFromChoices} value={formData.know_us_from} onChange={handleChange} />
                        <div>
                            <label className="block text-sm font-medium text-gray-700">Remarks</label>
                            <textarea name="remarks" rows={3} value={formData.remarks} onChange={handleChange} className="mt-1 block w-full rounded-md border-gray-300 shadow-sm border p-2" />
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-gray-700">Profile Picture</label>
                            <input type="file" accept="image/*" onChange={handleFileChange} className="mt-1 block w-full text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded-md file:border-0 file:text-sm file:font-semibold file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100" />
                        </div>
                    </div>
                </section>

                <div className="pt-4">
                    <button 
                        type="submit" 
                        disabled={loading}
                        className={`w-full md:w-auto flex justify-center py-3 px-8 border border-transparent rounded-md shadow-sm text-sm font-medium text-white ${loading ? 'bg-gray-400' : 'bg-blue-600 hover:bg-blue-700'} focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500`}
                    >
                        {loading ? 'Adding Member...' : 'Add Member'}
                    </button>
                </div>
            </form>
        </div>
    );
};

export default AddMember;
